import { ErrorType } from "./types";
export var isErrorType = function (type) {
    return Object.values(ErrorType).includes(type);
};
export var isApiError = function (error) {
    return typeof error === 'object'
        && error !== null
        && 'type' in error
        && isErrorType(error.type)
        && 'response' in error
        && (error.response === null || typeof error.response === 'object')
        && 'message' in error
        && typeof error.message === 'string';
};
export var isApiErrorOfType = function (error, type) {
    return isApiError(error)
        && isErrorType(type)
        && error.type === type;
};
export var isApiRequestError = function (error) {
    return isApiErrorOfType(error, ErrorType.Request);
};
export var isApiNotAuthorizedError = function (error) {
    return isApiErrorOfType(error, ErrorType.NotAuthorized);
};
export var isApiAccessDeniedError = function (error) {
    return isApiErrorOfType(error, ErrorType.AccessDenied);
};
export var isApiNotFoundError = function (error) {
    return isApiErrorOfType(error, ErrorType.NotFound);
};
export var isApiServerError = function (error) {
    return isApiErrorOfType(error, ErrorType.Server);
};
export var isApiValidationError = function (error) {
    return isApiErrorOfType(error, ErrorType.Validation);
};
export var isApiOfflineError = function (error) {
    return isApiErrorOfType(error, ErrorType.Offline);
};
export var isApiMaintenanceError = function (error) {
    return isApiErrorOfType(error, ErrorType.Maintenance);
};
export var isValidMessage = function (message) {
    return typeof message === 'string' && message.length > 0;
};
export var isErrorsList = function (value) {
    return typeof value === 'object'
        && value !== null
        && !Array.isArray(value)
        && Object.values(value).every(function (v) { return Array.isArray(v) && v.every(function (v) { return typeof v === 'string'; }); });
};
//# sourceMappingURL=guards.js.map